import { RouterProvider, createRouter } from '@tanstack/react-router';
import { useAuthContext } from '../../features/auth';

// Import the auto-generated route tree
import { useEffect, useMemo } from 'react';
import { routeTree } from '../../routeTree.gen';

// 1. Define the router context type. This is our type-level contract.
export type RouterContext = {
  auth: ReturnType<typeof useAuthContext>;
};

// 2. Create the router. We provide the context type here to make it type-safe.
const router = createRouter({
  routeTree,
  defaultPreload: false, //'viewport'
  // Provide the context type to the router. The value is provided by the wrapper.
  context: {} as RouterContext,
});

// 3. Register the router for type safety.
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// 4. Create the provider that gets the context and passes it down.
export function RouterProviderWrapper() {
  // Get the actual, populated auth object from the provider.
  const auth = useAuthContext();

  const contextValue = useMemo(() => ({ auth }), [auth]);

  useEffect(() => {
    router.invalidate().catch((err) => {
      console.error('[RouterProviderWrapper] router.invalidate failed:', err);
    });
  }, [auth.isAuthenticated, auth.isInitialized, auth.isLoading]);

  return <RouterProvider router={router} context={contextValue} />;
}

export default router;
